<template>
	<div class="playbook-rules">
		<!--eslint-disable vue/singleline-html-element-content-newline -->
		<div class="playbook-rules__heading">Personalization Rules Used:</div>
		<playbooks-card-rule v-for="slug in rules" :key="slug" :slug="slug" />
	</div>
</template>

<script>
export default {
	props: {
		rules: {
			type: Array,
			default: () => {},
		},
	},
};
</script>
